export function initFxPreviewListener() {
    // Listener per la preview in editing mode.
    // Non importiamo la classe FxTxtPreview subito, ma solo quando l'evento scatta.
    document.body.addEventListener('previewFx', () => {
        import('./text/fx_txt')
            .then(({ FxTxtPreview }) => {
                new FxTxtPreview();
            })
            .catch(err => console.error('Error loading FxTxtPreview:', err));
    }, false);
}
